import React, { Component, Fragment } from 'react';
import { message } from 'antd';
import _ from 'lodash';
import qs from 'query-string';
import GoogleMapReact from 'google-map-react';
import classnames from 'classnames';
import { __ } from '@wordpress/i18n';
import $ from 'jquery';

import './styles.module.scss';
import AppHelper from 'libs/AppHelper';
import { API_HOST, GOOGLE_MAP_KEY } from '../../configs/env';
import whttp from '../../libs/whttp';

const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL');
const INDEX_URL = _.get(window, 'VC_CONFIG.INDEX_URL');
const Locale = _.get(window, 'VC_CONFIG.Locale');
const stringToBr = (text) => {
  return _.map(_.split(text, '\n'), (line, idx) => (
    <Fragment key={idx}>
      {line}
      <br />
    </Fragment>
  ));
};

// 前端頁面
// 店基本資訊、地圖、美食外送、商店購物
// 美食購物分類、品牌購物分類
// 購物中心樓層介紹 （建議的）
export default class StoreInfo extends Component {
  state = {
    tabType: 'info',
    storeInfo: undefined,
    query: {},
  };

  componentDidMount() {
    this.loadConfig();
    this.setState({
      tabType: AppHelper.getHashValue('tab') || 'info',
    });

    this.loadData();
  }

  reloadTab = () => {
    // tab 共用動態
    var $el, leftPos, newWidth;
    /* Add Magic Line markup via JavaScript, because it ain't gonna work without */
    let $magicLine = $('#magic-line');

    if (!_.get($magicLine, 0)) {
      $('.basic-tabs-label ul').append("<li id='magic-line'></li>");
    }
    /* Cache it */
    $magicLine = $('#magic-line');

    $magicLine
      .width($('.current_page_item').width())
      .css('left', $('.current_page_item a').position().left)
      .data('origLeft', $magicLine.position().left)
      .data('origWidth', $magicLine.width());

    $('.basic-tabs-label ul li a').unbind('mouseenter mouseleave');
    $('.basic-tabs-label ul li')
      .find('a')
      .hover(
        function() {
          $el = $(this);
          //console.log('basic-tabs-label', $el)
          leftPos = $el.position().left;
          newWidth = $el.parent().width();

          $magicLine.stop().animate({
            left: leftPos,
            width: newWidth,
          });
        },
        function() {
          $magicLine.stop().animate({
            left: $magicLine.data('origLeft'),
            width: $magicLine.data('origWidth'),
          });
        }
      );

    $('#pills-tab .nav-item').unbind('mouseenter mouseleave');
    $('#pills-tab .nav-item')
      .mouseenter(function() {
        if (!$(this).hasClass('highlight')) {
          $('.highlight').removeClass('current_page_item');
        }
      })
      .mouseleave(function() {
        $('.highlight').addClass('current_page_item');
      });
  };

  loadConfig = () => {
    this.setState({ isLoadingData: true });

    whttp.get(API_HOST + '/api/v1/system/configs', {}, (state, res) => {
      this.setState({ isLoadingData: false });
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return this.setState({ message: '發生錯誤' });
      }

      if (code !== 200) {
        return this.setState({ message: reason });
      }

      this.setState({ options: data.options }, () => {
        this.refreshPicker();
      });
    });
  };

  loadData = () => {
    const urlQuery = AppHelper.getURLQuery();

    const store = _.get(urlQuery, 'store');

    if (!store) return this.props.history.replace('/stores');

    this.setState({ isFetchData: true });
    whttp.sharedGet(
      API_HOST + `/api/v1/stores/${store}`,
      null,
      (state, res) => {
        this.setState({ isFetchData: false });

        const { code = 100, reason = '發生錯誤', data = {} } = res;

        console.log(code, reason, data, res);

        if (state === false || code !== 200) {
          message.warning(reason);
          this.props.history.replace('/stores');
          return;
        }
        this.setState({ storeInfo: data }, () => {
          this.reloadMaps();
          this.reloadTab();
          this.ServiceCollapse();
        });
      }
    );
  };

  reloadMaps = () => {
    const { map, maps, storeInfo } = this.state;

    //console.log('reloadMaps', map, maps)

    if (!maps || !map || !storeInfo) return;

    const stores = [storeInfo];

    if (!_.isArray(stores) || stores.length === 0) return;

    if (Array.isArray(this.state.markers)) {
      this.state.markers.forEach((marker) => marker.setMap(null));
    }

    // zoom預設為能呈現出地形等高線的大小
    // 所以改成呈現最新的裝置位置
    let bounds = new maps.LatLngBounds();

    const markers = stores.map((store, idx) => {
      var icon = '';
      if (store.store_type_id == 2)
        icon = `${
          window.VC_CONFIG.INDEX_URL
        }/wp-content/themes/cec/assets/img/icon/cec-m-loc.png`;
      else
        icon = `${
          window.VC_CONFIG.INDEX_URL
        }/wp-content/themes/cec/assets/img/icon/cec-loc.png`;
      const marker = new maps.Marker({
        map: map,
        position: { lat: store.latitude, lng: store.longitude },
        store: store,
        icon: icon,
      });

      let infowindow = new maps.InfoWindow({
        content: `<div jstcache="33" class="poi-info-window gm-style"> <div jstcache="2"> <div jstcache="3" class="title full-width" jsan="7.title,7.full-width">${
          store.name
        }</div><div class="address"> <div jstcache="4" jsinstance="*0" class="address-line full-width" jsan="7.address-line,7.full-width">${
          store.address
        }</div> </div> </div>`,
      });
      marker.addListener('click', function() {
        infowindow.open(map, marker);
      });
      // marker.addListener('mouseover', function () {
      //   infowindow.open(map, marker);
      // });

      // marker.addListener('mouseout', function () {
      //   infowindow.close();
      // });

      if (idx == 0) {
        bounds.extend(marker.getPosition());
      }
      return marker;
    });

    map.fitBounds(bounds);

    map.setZoom(16);

    this.setState({ markers });
  };

  refreshPicker = _.debounce(() => {
    $('.selectpicker').selectpicker('refresh');
  }, 1000);

  handleQueryUpdate = (key, value) => {
    const query = _.get(this, 'state.query', {});
    _.set(query, key, value);
    this.setState({ query });
  };

  getSearchPath = (query) => {
    return (
      window.location.origin +
      `${window.VC_CONFIG.INDEX_URL}/stores/#` +
      qs.stringify(query, { skipNull: true })
    );
  };

  ServiceCollapse = () => {
    var iconCollapse = $('.icon_service-collapse');
    var iconCollapseIn = $('.icon_service-collapse-in');
    iconCollapse.css({
      height: $('.icon_service-block .inner').height() + 20 + 30 + 'px',
    });
    $(document).on(
      'click',
      '.icon_service-collapse .collapse-link',
      function() {
        $(this)
          .parent()
          .toggleClass('show');
        if (iconCollapse.hasClass('show')) {
          iconCollapse.css({ height: iconCollapseIn.height() + 24 + 'px' });
        } else {
          iconCollapse.css({
            height: $('.icon_service-block .inner').height() + 20 + 30 + 'px',
          });
        }
      }
    );
  };

  render() {
    const urlQuery = AppHelper.getURLQuery();
    const storeInfo = _.get(this, 'state.storeInfo', {});
    const tabType = _.get(this, 'state.tabType', {});
    const options = _.get(this, 'state.options', {});
    const query = _.get(this, 'state.query', {});
    const listInfo = _.get(this, 'props.stores.listInfo', []);
    const news = _.get(storeInfo, 'news', []);
    const services = _.get(storeInfo, 'services', []);
    const foods = _.get(storeInfo, 'foods', []);
    const brands = _.get(storeInfo, 'brands', []);
    const banners = _.get(storeInfo, 'banners', []);

    this.refreshPicker();
    const storeBanner = _.get(storeInfo, 'images.0');
    const Local = _.get(window, 'VC_CONFIG.Locale');

    return (
      <Fragment>
        <div class='bg-light'>
          <div class='container'>
            <div class='breadcrumb-wrap py-4 m-0'>
              <nav aria-label='breadcrumb'>
                <ol class='breadcrumb'>
                  <li class='breadcrumb-item'>
                    <a
                      href={`${window.VC_CONFIG.INDEX_URL}${
                        Local == 'en_US' ? '/en' : ''
                      }`}>
                      {__('首頁', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li class='breadcrumb-item'>
                    <a
                      href={`${window.VC_CONFIG.INDEX_URL}/stores${
                        Local == 'en_US' ? '-en' : ''
                      }`}>
                      {__('分店搜尋', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li
                    class='breadcrumb-item active'
                    aria-current='page'
                    id='name'>
                    {storeInfo.name}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
        <div class='banner-location'>
          {(storeInfo.en_name || storeInfo.name) && (
            <div class='banner-image'>
              <img
                src={
                  storeBanner
                    ? storeBanner
                    : `${PLUGIN_ASSETS_URL}img/banner/store/banner-store.png`
                }
                alt=''
              />
              {Local == 'en_US' && storeInfo.en_name && (
                <h3 class='title'>{`${storeInfo.en_name}`}</h3>
              )}
              {(Local == 'zh_TW' ||
                (Local == 'en_US' && !storeInfo.en_name)) &&
                storeInfo.name && (
                  <h3 class='title'>{`${storeInfo.name}`}</h3>
                )}
            </div>
          )}
        </div>

        <main class='bg-light'>
          <div class='mt-4'>
            <div class='mb-5 basic-tabs-label'>
              <ul class='nav nav-pills' id='pills-tab'>
                {_.map(
                  [
                    {
                      type: 'info',
                      name: __('分店資訊', 'cec-plugin-stores'),
                    },
                    {
                      type: 'foods',
                      name: __('美食餐廳', 'cec-plugin-stores'),
                    },
                    {
                      type: 'brands',
                      name: __('專櫃介紹', 'cec-plugin-stores'),
                    },
                  ],
                  (item) => (
                    <li
                      className={classnames(
                        'nav-item',
                        item.type === tabType
                          ? 'current_page_item highlight'
                          : null,
                      )}
                      key={item.type}>
                      {item.type == 'info' && (
                        <a
                          className={classnames('nav-link')}
                          href={`${INDEX_URL}/store-info${
                            Locale == 'en_US' ? '-en' : ''
                          }/?store=${urlQuery.store}#tab=${item.type}`}
                          onClick={() =>
                            this.setState({ tabType: item.type }, () => {
                              this.reloadTab()
                            })
                          }>
                          {item.name}
                        </a>
                      )}
                      {item.type == 'foods' &&
                        _.isArray(foods) &&
                        foods.length > 0 && (
                          <a
                            className={classnames('nav-link')}
                            href={`${INDEX_URL}/store-info${
                              Locale == 'en_US' ? '-en' : ''
                            }/?store=${urlQuery.store}#tab=${item.type}`}
                            onClick={() =>
                              this.setState({ tabType: item.type }, () => {
                                this.reloadTab()
                              })
                            }>
                            {item.name}
                          </a>
                        )}
                      {item.type == 'brands' &&
                        _.isArray(brands) &&
                        brands.length > 0 && (
                          <a
                            className={classnames('nav-link')}
                            href={`${INDEX_URL}/store-info${
                              Locale == 'en_US' ? '-en' : ''
                            }/?store=${urlQuery.store}#tab=${item.type}`}
                            onClick={() =>
                              this.setState({ tabType: item.type }, () => {
                                this.reloadTab()
                              })
                            }>
                            {item.name}
                          </a>
                        )}
                    </li>
                  ),
                )}
              </ul>
            </div>
          </div>
          {tabType === 'info' && (
            <Fragment>
              <div class='container'>
                <div class='breadcrumb-wrap pt-3' />
                <h4 class='heading-title justify-content-center'>
                  {(Local == 'zh_TW' ||
                    (Local == 'en_US' && !storeInfo.en_name)) &&
                    storeInfo.name &&
                    storeInfo.name}
                  {Local == 'en_US' &&
                    storeInfo.en_name &&
                    storeInfo.en_name}
                  {/* <span class="add-favorite"><a role="button" href="javascript:void(0)">加入我的最愛<i class="icon-store_heart2"></i></a></span> */}
                </h4>
                <hr class='border-top border-primary mt-0 mb-5' />
              </div>
              <div class='map-section' id='map'>
                <GoogleMapReact
                  bootstrapURLKeys={{ key: GOOGLE_MAP_KEY }}
                  defaultCenter={[25.1243218, 121.4971524]}
                  defaultZoom={13}
                  options={{
                    mapTypeControl: false,
                    styles: [{ elementType: 'all' }],
                  }}
                  onGoogleApiLoaded={({ map, maps }) =>
                    this.setState({ map, maps }, () => this.reloadMaps())
                  }
                />
              </div>
              <div class='container'>
                <div class='store-traffic-info my-5'>
                  <div class='row'>
                    <div class='col-12'>
                      <div class='d-flex justify-content-between align-items-center pb-3 mb-3 border-bottom'>
                        <h6 class='h6 text-navy mb-0'>基本資訊</h6>
                        <a
                          class='h4 mb-0'
                          role='button'
                          href={
                            storeInfo.fb ||
                            'https://www.facebook.com/prosperity.tw/'
                          }
                          target='_blank'>
                          {' '}
                          <i class='fab fa-facebook' />
                        </a>
                      </div>
                    </div>
                    <div class='col-md-6 col-lg-3'>
                      <ul class='traffic-info-list'>
                        <li>
                          <i class='icon-store_map' />
                          <span>
                            {(Local == 'zh_TW' ||
                              (Local == 'en_US' && !storeInfo.address)) &&
                              storeInfo.address &&
                              storeInfo.address}{' '}
                            {Local == 'en_US' &&
                              storeInfo.en_street &&
                              storeInfo.en_street}
                            <a
                              class='gMap-link'
                              role='button'
                              // href={`https://www.google.com.tw/maps/place/${
                              //   storeInfo.address
                              // }`}
                              href={
                                storeInfo.store_link
                                  ? storeInfo.store_link
                                  : `https://www.google.com.tw/maps/place/${
                                      storeInfo.address
                                    }`
                              }
                              target='_blank'>
                              <img
                                class='ml-3'
                                src={`${PLUGIN_ASSETS_URL}img/icon/google_map.svg`}
                                alt='map'
                              />
                            </a>
                          </span>
                        </li>
                        {storeInfo.contact_tel && (
                          <li>
                            {' '}
                            <i class='icon-store_phone' />
                            <span>
                              <a href={`tel:+886-${storeInfo.contact_tel}`}>
                                {storeInfo.contact_tel}
                              </a>
                            </span>
                          </li>
                        )}
                        {storeInfo.contact_fax && (
                          <li>
                            {' '}
                            <i class='icon-fax' />
                            <span>{storeInfo.contact_fax}</span>
                          </li>
                        )}
                      </ul>
                    </div>
                    {storeInfo.business_hours && (
                      <div class='col-md-6 col-lg-3'>
                        <ul class='traffic-info-list'>
                          <li>
                            <i class='icon-store_clock' />
                            <span>
                              {__('營業時間', 'cec-plugin-stores')}
                              <br />
                              {Local == 'en_US' &&
                                storeInfo.en_business_hours &&
                                stringToBr(
                                  (storeInfo.en_business_hours
                                    ? storeInfo.en_business_hours
                                    : ''
                                  )
                                    .split('<BR>')
                                    .join(''),
                                )}
                              {(Local == 'zh_TW' ||
                                (Local == 'en_US' &&
                                  !storeInfo.en_business_hours)) &&
                                stringToBr(
                                  (storeInfo.business_hours
                                    ? storeInfo.business_hours
                                    : ''
                                  )
                                    .split('<BR>')
                                    .join(''),
                                )}
                            </span>
                          </li>
                        </ul>
                      </div>
                    )}
                    {storeInfo.business_hours_special && Local == 'zh_TW' && (
                      <div class='col-md-6 col-lg-3'>
                        <ul class='traffic-info-list'>
                          <li>
                            {' '}
                            <i class='icon-store_conversation' />
                            <span>
                              {stringToBr(
                                (storeInfo.business_hours_special
                                  ? storeInfo.business_hours_special
                                  : ''
                                )
                                  .split('<BR>')
                                  .join(''),
                              )}
                            </span>
                          </li>
                        </ul>
                      </div>
                    )}
                    {storeInfo.en_business_hours_special &&
                      Local == 'en_US' && (
                        <div class='col-md-6 col-lg-3'>
                          <ul class='traffic-info-list'>
                            <li>
                              {' '}
                              <i class='icon-store_conversation' />
                              <span>
                                {stringToBr(
                                  (storeInfo.en_business_hours_special
                                    ? storeInfo.en_business_hours_special
                                    : ''
                                  )
                                    .split('<BR>')
                                    .join(''),
                                )}
                              </span>
                            </li>
                          </ul>
                        </div>
                      )}
                    <div class='col-md-6 col-lg-3'>
                      <ul class='traffic-info-list'>
                        {((storeInfo.bus_info && Local == 'zh_TW') ||
                          (!storeInfo.en_bus_info && Local == 'en_US')) && (
                          <li>
                            <i class='icon-store_bus' />
                            <span>
                              {__('公車交通方式', 'cec-plugin-stores')}
                              <br />
                              {stringToBr(
                                (storeInfo.bus_info
                                  ? storeInfo.bus_info
                                  : ''
                                )
                                  .split('<BR>')
                                  .join(''),
                              )}
                            </span>
                          </li>
                        )}
                        {storeInfo.en_bus_info && Local == 'en_US' && (
                          <li>
                            <i class='icon-store_bus' />
                            <span>
                              {__('公車交通方式', 'cec-plugin-stores')}
                              <br />
                              {stringToBr(
                                (storeInfo.en_bus_info
                                  ? storeInfo.en_bus_info
                                  : ''
                                )
                                  .split('<BR>')
                                  .join(''),
                              )}
                            </span>
                          </li>
                        )}
                        {((storeInfo.traffic_info && Local == 'zh_TW') ||
                          (!storeInfo.en_traffic_info &&
                            Local == 'en_US')) && (
                          <li>
                            <i class='icon-store_train' />
                            <span>
                              {__('其他交通方式', 'cec-plugin-stores')}
                              <br />
                              {stringToBr(
                                (storeInfo.traffic_info
                                  ? storeInfo.traffic_info
                                  : ''
                                )
                                  .split('<BR>')
                                  .join(''),
                              )}
                            </span>
                          </li>
                        )}
                        {storeInfo.en_traffic_info && Local == 'en_US' && (
                          <li>
                            <i class='icon-store_train' />
                            <span>
                              {__('其他交通方式', 'cec-plugin-stores')}
                              <br />
                              {stringToBr(
                                (storeInfo.en_traffic_info
                                  ? storeInfo.en_traffic_info
                                  : ''
                                )
                                  .split('<BR>')
                                  .join(''),
                              )}
                            </span>
                          </li>
                        )}
                      </ul>
                    </div>
                    <div class='col-12'>
                      <h6 class='h6 text-navy py-3 mb-3 border-bottom'>
                        停車資訊
                      </h6>
                    </div>
                    <div class='col-md-6 col-lg-3'>
                      <ul class='traffic-info-list'>
                        <li>
                          <i class='icon-store_car' />
                          <span>
                            {__('停車資訊', 'cec-plugin-stores')}
                            <br />
                            {__('汽車停車位', 'cec-plugin-stores')}{' '}
                            {!storeInfo.parking_spaces_car &&
                              storeInfo.parking_spaces_car != 0 &&
                              0}
                            {storeInfo.parking_spaces_car &&
                              storeInfo.parking_spaces_car}{' '}
                            {__('位', 'cec-plugin-stores')} <br />
                            {__('機車停車位', 'cec-plugin-stores')}{' '}
                            {!storeInfo.parking_spaces_moto &&
                              storeInfo.parking_spaces_moto != 0 &&
                              0}
                            {storeInfo.parking_spaces_moto &&
                              storeInfo.parking_spaces_moto}{' '}
                            {__('位', 'cec-plugin-stores')}
                            <br />
                            {__('汽車無障礙車位', 'cec-plugin-stores')}{' '}
                            {!storeInfo.parking_spaces_handicapped &&
                              storeInfo.parking_spaces_handicapped != 0 &&
                              0}
                            {storeInfo.parking_spaces_handicapped &&
                              storeInfo.parking_spaces_handicapped}{' '}
                            {__('位', 'cec-plugin-stores')}
                            <br />
                            {__('親子車位', 'cec-plugin-stores')}{' '}
                            {!storeInfo.parking_spaces_parent &&
                              storeInfo.parking_spaces_parent != 0 &&
                              0}
                            {storeInfo.parking_spaces_parent &&
                              storeInfo.parking_spaces_parent}{' '}
                            {__('位', 'cec-plugin-stores')}
                            <br />
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div class='col-md-6 col-lg-9'>
                      <ul class='traffic-info-list'>
                        <li>
                          <i class='icon-parking' />
                          <span>
                            {__('停車收費方式', 'cec-plugin-stores')}
                            <br />
                            {((Local == 'zh_TW' &&
                              storeInfo.parking_info) ||
                              (Local == 'en_US' &&
                                !storeInfo.en_parking_info)) &&
                              stringToBr(
                                (storeInfo.parking_info
                                  ? storeInfo.parking_info
                                  : ''
                                )
                                  .split('<BR>')
                                  .join(''),
                              )}
                            {Local == 'en_US' &&
                              storeInfo.en_parking_info &&
                              stringToBr(
                                (storeInfo.en_parking_info
                                  ? storeInfo.en_parking_info
                                  : ''
                                )
                                  .split('<BR>')
                                  .join(''),
                              )}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {_.isArray(services) && services.length > 0 && (
                  <Fragment>
                    <h4 class='heading-title align-items-center'>
                      {__('分店服務', 'cec-plugin-stores')}
                    </h4>
                    <hr class='border-top border-gray mt-0 mb-4' />
                    <div class='icon_service-collapse'>
                      <div class='icon_service-collapse-in row no-gutters mx-n3'>
                        {_.map(services, (serviceInfo) => (
                          <div class='col-6 col-sm-4 col-md-3 col-lg-auto icon_service-wrap px-3'>
                            <a
                              role='button'
                              class='icon_service-block'
                              // href='javascript:void(0)'
                              data-toggle='modal'
                              data-target={`#icon-service-modal-${
                                serviceInfo.id
                              }`}
                              onClick={(e) => e.preventDefault()}>
                              <span class='inner'>
                                <img
                                  src={serviceInfo.icon}
                                  alt={serviceInfo.name}
                                />
                                <span class='name'>{serviceInfo.name}</span>
                              </span>
                            </a>
                          </div>
                        ))}
                      </div>
                      <a
                        class='collapse-link'
                        // href='javascript:void(0);'
                        role='button'
                        onClick={(e) => e.preventDefault()}>
                        <span>
                          <i class='fas fa-angle-double-down' />
                        </span>
                      </a>
                    </div>
                    {_.map(services, (serviceInfo) => (
                      <div
                        class='modal fade'
                        id={`icon-service-modal-${serviceInfo.id}`}
                        tabindex='-1'
                        role='dialog'
                        aria-labelledby='icon-service-modalTitle'
                        aria-hidden='true'>
                        <div
                          class='modal-dialog modal-dialog-centered'
                          role='document'>
                          <div class='modal-content'>
                            <div class='modal-header border-0'>
                              <button
                                class='text-navy close'
                                type='button'
                                data-dismiss='modal'
                                aria-label='Close'>
                                <span class='text-navy' aria-hidden='true'>
                                  ×
                                </span>
                              </button>
                            </div>
                            <div class='modal-body px-5 pb-5'>
                              <div class='row'>
                                <div class='col-3'>
                                  <img
                                    style={{ width: '100%' }}
                                    src={serviceInfo.icon}
                                    alt={serviceInfo.name}
                                  />
                                </div>
                                <div class='col-9'>
                                  <h6 class='h4 text-navy mb-4'>
                                    {serviceInfo.name}
                                  </h6>
                                  <p class='h6 fw-300 text-font text-justify'>
                                    {serviceInfo.desc}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Fragment>
                )}

                <div class='row my-5'>
                  {_.find(
                    storeInfo.deliveries,
                    (vendor) => vendor.vendor_type === 1,
                  ) !== undefined && (
                    <div class='col-md-6 mb-md-0 mb-4'>
                      <a
                        class='d-block bg-sky text-decoration-none p-4'
                        role='button'
                        href={`${
                          window.VC_CONFIG.INDEX_URL
                        }/store-vendor?type=1&id=${storeInfo.id}`}>
                        <div class='p-2'>
                          <h5 class='h6 text-center mb-5'>
                            {__('美食外送', 'cec-plugin-stores')}
                          </h5>
                          <div class='row'>
                            <div class='col-md-10 col-lg-9 mx-auto'>
                              <img
                                class='img-contain'
                                src={`${PLUGIN_ASSETS_URL}img/store/svg/delivery.svg`}
                                alt='美食外送'
                              />
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  )}
                  {_.find(
                    storeInfo.deliveries,
                    (vendor) => vendor.vendor_type === 2,
                  ) !== undefined && (
                    <div class='col-md-6 mb-md-0 mb-4'>
                      <a
                        class='d-block bg-sky text-decoration-none p-4'
                        role='button'
                        href={`${
                          window.VC_CONFIG.INDEX_URL
                        }/store-vendor?type=2&id=${storeInfo.id}`}>
                        <div class='p-2'>
                          <h5 class='h6 text-center mb-5'>
                            {__('商店購物', 'cec-plugin-stores')}
                          </h5>
                          <div class='row'>
                            <div class='col-md-10 col-lg-9 mx-auto'>
                              <img
                                class='img-contain'
                                src={`${PLUGIN_ASSETS_URL}img/store/svg/ec.svg`}
                                alt='商店購物'
                              />
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  )}
                </div>
                {_.isArray(banners) && banners.length > 0 && (
                  <Fragment>
                    <h4 class='heading-title justify-content-center'>
                      {__('分店活動', 'cec-plugin-stores')}
                    </h4>
                    <hr class='border-top border-gray mt-0 mb-4' />
                    <div class='row no-gutters mx-n3'>
                      {banners.map((banner) => {
                        return (
                          <div className='col-md-6 px-3 mb-4'>
                            <a
                              class='card h-100 text-decoration-none border-0 shadow-0 p-0'
                              role='button'
                              href={banner.link}>
                              <div
                                class='img-2-1'
                                style={{
                                  backgroundImage: `url(${banner.url})`,
                                }}
                              />
                            </a>
                          </div>
                        )
                      })}
                    </div>
                  </Fragment>
                )}
              </div>
            </Fragment>
          )}
          {/* 美食餐廳與品牌購物 */}
          {[
            {
              type: 'foods',
              name: __('美食餐廳', 'cec-plugin-stores'),
            },
            {
              type: 'brands',
              name: __('專櫃介紹', 'cec-plugin-stores'),
            },
          ]
            .filter((tabInfo) => tabInfo.type === tabType)
            .map((tabInfo) => (
              <Fragment>
                <div class='container'>
                  <h4 class='heading-title justify-content-center'>
                    {tabInfo.name}
                  </h4>
                  <hr class='border-top border-navy mt-0 mb-4' />
                  <div class='mb-5'>
                    <div class='row'>
                      {_.map(
                        _.get(storeInfo, tabInfo.type, []),
                        (brandInfo) => (
                          <div class='col-4 col-md-3 col-lg-2 my-4'>
                            <a
                              role='button'
                              class='store-brand-logo-link'
                              href={`${INDEX_URL}/brand-info${
                                Locale == 'en_US' ? '-en' : ''
                              }/?brand=${brandInfo.name}`}>
                              <img
                                src={brandInfo.logo}
                                alt={brandInfo.name}
                              />
                            </a>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                </div>
              </Fragment>
            ))}
          {/* {tabType === 'foods' && <Fragment>品牌購物</Fragment>} */}
        </main>
      </Fragment>
    )
  }
}

// 編輯器
export class StoreInfoEditor extends Component {
  render() {
    return <div className='vu-blocks-editor'>編輯器</div>;
  }
}



// WEBPACK FOOTER //
// ./src/blocks/stores/store-info.js